export default "/images/vendor/flag-icon-css/flags/4x3/gq.svg?d338046f390d50e31f3cf1d2684f3f2f";